import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AffiliateService } from '../core/services/affiliate.service';
import { catchError, concatMap, of } from 'rxjs';
import { OrderType } from '../core/enums';
import { TranslocoService, getBrowserLang } from '@jsverse/transloco';
import { Affiliate } from '../core/models';
import { MainService } from '../core/services/main.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'app-affiliates',
	standalone: true,
	templateUrl: './affiliates.component.html',
	styleUrls: ['./affiliates.component.css'],
})

/**
 * Could probably be handled by guard, but may use this page to display offers as well. TBD.
 */
export class AffiliateRoutingComponent implements OnInit {

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private affiliateService: AffiliateService,
		private mainService: MainService,
		private transloco: TranslocoService
	) { }

	ngOnInit(): void {
		this.route.params.pipe(takeUntilDestroyed(), concatMap(params => {
			if (params['aidOrSlug'] == null) return of(null);
			else return this.affiliateService.fetch(params['aidOrSlug'])
		}), catchError(_ => {
			return of(null)
		})).subscribe((affiliate: Affiliate) => {
			if (affiliate == null) return this.router.navigate(['/']);
			else {
				let language = this.transloco.getActiveLang() || getBrowserLang() || 'en';
				this.mainService.persistAffiliate(affiliate);
				this.affiliateService.affiliate = affiliate;
				if (affiliate.type == OrderType.GiftBox) this.router.navigate([language, 'cadeaux']);
			}
		});
	}
}
